export const DEFAULT_CAROUSEL_SETTINGS = {
  infinite: false,
  maxVisibleDots: 5,
  enableSwipe: true,
};
export const MAX_IMAGES_IN_CAROUSEL = 100;
